import type { ProjectConnectConfig } from '@/types/connectData'

/** 登录指纹：地址（去尾斜杠）+ 账号 + 组织；换任一项须重新登录 */
export function connectAuthProfileKey(cfg: Pick<ProjectConnectConfig, 'baseUrl' | 'username' | 'organizationId'>): string {
  const baseUrl = cfg.baseUrl.trim().replace(/\/+$/, '')
  const username = cfg.username.trim()
  const organizationId = cfg.organizationId.trim()
  return `${baseUrl}|${username}|${organizationId}`
}
